module.exports = __webpack_public_path__ + "img/wait_time_blk.b87e51ae.svg";